var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/*
 * Copyright (c) 2019-present Sonatype, Inc.
 * This program and the accompanying materials are made available under
 * the terms of the Eclipse Public License 2.0 which accompanies this
 * distribution and is available at https://www.eclipse.org/legal/epl-2.0/.
 */
import React, { forwardRef } from 'react';
import classnames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import './NxCheckbox.scss';
import { propTypes } from './types';
/**
 * A stateless component for rendering a checkbox with a label
 * @param props.checkboxId An id to identify the checkbox
 * @param props.onChange A callback for when the checkbox is toggled
 * @param props.isChecked Whether the checkbox should be rendered as checked or unchecked
 * @param props.disabled Whether the checkbox should be rendered as disabled or not.  When disabled, the onChange
 * callback will not fire
 * @param props.children VDOM rendered as label. Should be
 * [phrasing content](https://www.w3.org/TR/2011/WD-html-markup-20110525/terminology.html#phrasing-content).
 */
var NxCheckbox = forwardRef(function NxCheckbox(_a, ref) {
    var onChange = _a.onChange, isChecked = _a.isChecked, disabled = _a.disabled, checkboxId = _a.checkboxId, children = _a.children, otherProps = __rest(_a, ["onChange", "isChecked", "disabled", "checkboxId", "children"]);
    var labelClasses = classnames('nx-radio-checkbox', 'nx-checkbox', {
        'nx-radio-checkbox--disabled': disabled,
        'tm-checked': isChecked,
        'tm-unchecked': !isChecked
    });
    return (React.createElement("label", __assign({}, otherProps, { ref: ref, className: labelClasses }),
        React.createElement("input", { type: "checkbox", id: checkboxId || undefined, className: "nx-radio-checkbox__input nx-checkbox__input", disabled: !!disabled, checked: isChecked, readOnly: !onChange, onChange: onChange || undefined }),
        React.createElement("span", { className: "nx-radio-checkbox__control nx-checkbox__box" }, isChecked ? React.createElement(FontAwesomeIcon, { icon: faCheck }) : '\u00A0'),
        children && React.createElement("span", { className: "nx-radio-checkbox__content nx-checkbox__content" }, children)));
});
NxCheckbox.propTypes = propTypes;
export default NxCheckbox;
//# sourceMappingURL=NxCheckbox.js.map